"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  gender: {
    id: "window.hiring.columnHeader.gender",
    defaultMessage: "GE",
    description: ""
  },
  race: {
    id: "window.hiring.columnHeader.race",
    defaultMessage: "Race",
    description: ""
  },
  class: {
    id: "window.hiring.columnHeader.class",
    defaultMessage: "Class",
    description: ""
  },
  level: {
    id: "window.hiring.columnHeader.level",
    defaultMessage: "Level",
    description: ""
  },
  gp: {
    id: "window.hiring.columnHeader.gp",
    defaultMessage: "GP",
    description: ""
  },
  hire: {
    id: "window.hiring.button.hire",
    defaultMessage: "Hire",
    description: ""
  }
});

exports.default = _default;